// Танаки — active: «1 раз за матч получи +4 Влияния».
// Кулдаун = match. Флаг: state.players[idx].heroActiveUsed.

import { addInfluence } from './influence.js';

export const HERO_ID = 'deus_tanaki';

export function tanakiActiveAvailable(state, playerIdx) {
  const p = state.players[playerIdx];
  if (!p || p.hero.id !== HERO_ID) return false;
  return !p.heroActiveUsed;
}

export function tanakiActive(state, playerIdx) {
  if (!tanakiActiveAvailable(state, playerIdx)) return false;
  state.players[playerIdx].heroActiveUsed = true;
  addInfluence(state, playerIdx, 4, 'Танаки [active]');
  return true;
}
